import { trackEvent } from '@fs/zion-analytics'

export function imageSearchAnalytics() {
  trackEvent({ event_name: 'click_action', link_name: 'Image Search' })
}

export function showMoreAnalytics() {
  trackEvent({ event_name: 'click_action', link_name: 'Show More Search Options' })
}
